import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const SimpleDebug = () => {
  const { user, currentUser, loading } = useAuth();

  console.log('Auth Context Debug:', {
    user,
    currentUser,
    loading,
    userType: typeof user,
    userKeys: user ? Object.keys(user) : 'null'
  });

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace', background: '#f8f9fa' }}>
      <h2>Simple Auth Debug</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Auth Context Loading:</h3>
        <p style={{ color: loading ? 'orange' : 'green' }}>
          {loading ? 'TRUE (still loading)' : 'FALSE (loaded)'}
        </p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>User Object:</h3>
        <p style={{ color: user ? 'green' : 'red' }}>
          {user ? 'EXISTS' : 'NULL'}
        </p>
        {user && (
          <pre style={{ background: '#fff', padding: '10px', border: '1px solid #ccc' }}>
            {JSON.stringify({
              uid: user.uid || 'missing',
              email: user.email || 'missing',
              displayName: user.displayName || 'missing',
              emailVerified: user.emailVerified || 'missing'
            }, null, 2)}
          </pre>
        )}
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Current User Object:</h3>
        <p style={{ color: currentUser ? 'green' : 'red' }}>
          {currentUser ? 'EXISTS' : 'NULL'}
        </p>
        {currentUser && (
          <pre style={{ background: '#fff', padding: '10px', border: '1px solid #ccc' }}>
            {JSON.stringify({
              uid: currentUser.uid || 'missing',
              email: currentUser.email || 'missing',
              displayName: currentUser.displayName || 'missing',
              isAdmin: currentUser.isAdmin || 'missing'
            }, null, 2)}
          </pre>
        )}
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Browser Console:</h3>
        <p>Check the browser console (F12) for any errors</p>
        <button 
          onClick={() => console.log('Test console log from debug component')}
          style={{ padding: '10px', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}
        >
          Test Console Log
        </button>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Navigation:</h3>
        <a href="/login" style={{ marginRight: '10px', color: '#007bff' }}>Go to Login</a>
        <a href="/attendance" style={{ marginRight: '10px', color: '#007bff' }}>Go to Attendance</a>
        <a href="/admin" style={{ marginRight: '10px', color: '#007bff' }}>Go to Admin</a>
      </div>

      <div>
        <h3>Troubleshooting Steps:</h3>
        <ol>
          <li>If "Auth Context Loading" is TRUE: Wait for authentication to complete</li>
          <li>If "User Object" is NULL: Go to /login and sign in</li>
          <li>If user exists but attendance is stuck: Firebase connection issue</li>
          <li>Check browser console for specific errors</li>
        </ol>
      </div>
    </div>
  );
};

export default SimpleDebug;